import { render, staticRenderFns } from "@/components/Layout/Menu/Reportes/Reporte_equipos_gt/Reporte_equipos_gt.html?vue&type=template&id=235c741a&scoped=true&"
import script from "@/components/Layout/Menu/Reportes/Reporte_equipos_gt/Reporte_equipos_gt.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Reportes/Reporte_equipos_gt/Reporte_equipos_gt.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Reportes/Reporte_equipos_gt/Reporte_equipos_gt.css?vue&type=style&index=0&id=235c741a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c741a",
  null
  
)

export default component.exports